import React from 'react';

import PackageIncludesMessage from '../../../../components/package-includes-message/package-includes-message';
import ProductFlags from '../../../../components/product-flags/product-flags';
import ProductImageGallery, {
  GalleryImages
} from '../../../../components/product-image-gallery/product-image-gallery';

import { useContainerQuery } from '../../../../shared/hooks/hooks';

import { getGalleryImagesByProductType } from '../../../../shared/utils/product-detail-utils/product-detail-utils';

import {
  BundleData,
  ProductData,
  SwatchImageData
} from '../../../../shared/types/graphql-types';
import { PRODUCT_TYPES } from '../../../../shared/constants/products';

interface PdpGallerySectionProps {
  fallbackProductImage: string;
  galleryImages: GalleryImages;
  hideTreadwellRank?: boolean;
  isNoLongerAvailable: boolean;
  prebuiltPackage: BundleData;
  product: ProductData;
  selectedSwatch?: SwatchImageData;
  showFallbackProductImage?: boolean;
}

function PdpGallerySection(props: PdpGallerySectionProps) {
  const {
    fallbackProductImage,
    galleryImages,
    hideTreadwellRank,
    isNoLongerAvailable,
    prebuiltPackage,
    product,
    selectedSwatch,
    showFallbackProductImage
  } = props;

  const breakpoint = useContainerQuery();

  return (
    <>
      {!breakpoint.isMinSm && !isNoLongerAvailable && prebuiltPackage && (
        <PackageIncludesMessage isPrebuiltPackage />
      )}

      <ProductFlags
        className="pdp-gallery-section__product-flags"
        hideTreadwellRank={hideTreadwellRank}
        hideWebOnly
        prebuiltPackage={prebuiltPackage}
        product={product}
      />

      <ProductImageGallery
        fallbackProductImage={fallbackProductImage}
        galleryImages={
          prebuiltPackage
            ? getGalleryImagesByProductType(galleryImages, PRODUCT_TYPES.TIRES)
            : galleryImages
        }
        product={prebuiltPackage ? prebuiltPackage.product1 : product}
        selectedSwatch={selectedSwatch}
        showFallbackProductImage={showFallbackProductImage}
      />

      {breakpoint.isMinSm && prebuiltPackage && (
        <ProductImageGallery
          fallbackProductImage={fallbackProductImage}
          galleryImages={getGalleryImagesByProductType(
            galleryImages,
            PRODUCT_TYPES.WHEELS
          )}
          product={prebuiltPackage.product2}
          showFallbackProductImage={showFallbackProductImage}
        />
      )}
    </>
  );
}

export default PdpGallerySection;
